import React, { FC, useState, useEffect } from "react";
import "./header.style.scss";
import { Row, Col, Avatar, Breadcrumb, Select, Button } from "antd";
import { useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
// import { UserOutlined } from "@ant-design/icons";
import { useGlobalDispatch } from "../../context/Provider";
import { languageList } from "../../constants/header.constant";
import { changeLanguages } from "../../context/lang/lang.action";
import { MenuOutlined } from "@ant-design/icons";
import { GetMyProfile } from "../../api/global";

interface HeaderIprops {
  setVisible: (value: boolean) => void;
}

const Header: FC<HeaderIprops> = ({ setVisible }) => {
  const { Option } = Select;
  const { pathname } = useLocation();
  const [name, setName] = useState("");
  const route: any = pathname.split("/").slice(1, 3);
  const { langDispatch: dispatch }: any = useGlobalDispatch();
  const lang: any = localStorage.getItem("lang");

  const handleChangeLanguage = (value: any) => {
    dispatch(changeLanguages({ lang: value })); // en-US - fa-IR
    localStorage.setItem("lang", value);
  };

  const handleProfile = () => {
    GetMyProfile().then((res: any) => {
      if (res.status === 200) {
        setName(res.data.name);
      }
    });
  };
  useEffect(() => {
    handleProfile();
  }, []);
  const logout=()=>{
    localStorage.removeItem('access_token');
    document.location.href="/";
  }
  return (
    <>
      <div className="header">
        <Row justify="center">
          <Col span={23}>
            <Row justify="space-between" align="middle">
              <Col> 
                <Breadcrumb>
                  {route.map((item: string, index: number) => (
                    <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
                  ))}
                </Breadcrumb>
              </Col>

              <div>
                <img width={140} height={50} src={logo} alt="" />
              </div>

              <Col>
                <h4> {name} <a onClick={logout}>(logout)</a></h4>

                {/* <Select
                  defaultValue={lang ? lang : "fa-IR"}
                  onChange={handleChangeLanguage}
                  disabled
                >
                  {languageList.map((Item: any) => (
                    <Option value={Item.value} key={Item.value}>
                      <img src={Item.src} alt={Item.alt} />
                    </Option>
                  ))}
                </Select> */}
              </Col>
              <Col md={0}>
                <Button
                  shape="circle"
                  icon={<MenuOutlined />}
                  onClick={() => setVisible(true)}
                  size="large"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Header;
